import $ from 'jquery';
import Popper from 'popper.js';

function toggleDropdown(trigger) {
  let dropdown = trigger.closest('.dropdown');
  let body = dropdown.find('.dropdown__body').first();
  let isHidden = body.is(':hidden');
  $('.dropdown__body').hide();
  if (isHidden) {
    body.show();
    let popper = new Popper(trigger, body, {
      placement: 'bottom'
    });
    dropdown.data('popper', popper);
  } else {
    body.hide();
  }
}

function showDropdown(trigger) {
  let dropdown = trigger.closest('.dropdown');
  let body = dropdown.find('.dropdown__body').first();
  $('.dropdown__body').hide();
  body.show();
  let popper = new Popper(trigger, body, {
    placement: 'bottom'
  });
  dropdown.data('popper', popper);
}

function hideAllDropdowns() {
  $('.dropdown__body').hide();
}

export { toggleDropdown, showDropdown, hideAllDropdowns };
